import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  constructor(private socket: Socket) { }

  // Listen socket based on consult id
  consultListner(consult_id: number): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('consult:' + consult_id, (res: any) => {
        observer.next(res);
      });
    });
  }

  // Remove Listening socket based on consult id
  removeConsultListener(consult_id: number): void {
    this.socket.removeListener('consult:' + consult_id);
  }

  liveConsultPublisherListner(ref_number?: any): Observable<any> {
    return new Observable((observer) => {
      this.socket.on('consultPublisher:' + ref_number, (res: any) => {
        // console.log('socket on');
        observer.next(res);
      });
    });
  }

  removeLiveConsultPublisherListner(ref_number?: any): void {
    // console.log('socket off');
    this.socket.removeListener('consultPublisher:' + ref_number);
  }

  liveConsultSubscriberListner(ref_number?: any): Observable<any> {
    // console.log('socket on');
    return new Observable((observer) => {
      this.socket.on('consultSubscriber:' + ref_number, (res: any) => {
        // console.log('socket observe');
        observer.next(res);
      });
    });
  }

  removeLiveConsultSubscriberListner(ref_number?: any): void {
    // console.log('socket off');
    this.socket.removeListener('consultSubscriber:' + ref_number);
  }

  // Listen socket based on consult id
  ptzListner(consult_id: number): Observable<any> {
    // console.log('ptzListner vehicle socket on');
    return new Observable((observer) => {
      this.socket.on('consultPtzAction:' + consult_id, (res: any) => {
        // console.log('ptzListner socket observe');
        observer.next(res);
      });
    });
  }

  // Remove Listening socket based on consult id
  removeptzListner(consult_id: number): void {
    // console.log('ptzListner vehicle socket off');
    this.socket.removeListener('consultPtzAction:' + consult_id);
  }
}
